var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { mapGetters } from "vuex";
export default {
    name: "options_menu_select",
    props: ["initialMode"],
    watch: {
        sharingScreenAndVideo: function (allowed) {
            this.sharingScreenAndVideo = allowed;
        }
    },
    computed: __assign(__assign({}, mapGetters(["supportMusic", "sharingScreenAndVideo", "sharingScreenOnly"])), { videoFlipped: {
            get: function () {
                return this.$store.getters.videoFlipped;
            },
            set: function (val) {
                this.$store.dispatch("updateVideoFlipped", val);
            }
        }, audioProcessingDisabled: {
            get: function () {
                return this.$store.getters.audioProcessingDisabled;
            },
            set: function (val) {
                this.$store.dispatch("updateAudioProcessingDisabled", val);
            }
        } }),
    methods: {
        getScreenShareStream: function () {
            return __awaiter(this, void 0, void 0, function () {
                var stream, err_1;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 3, , 4]);
                            stream = this.$store.getters.localScreenStream;
                            if (!!stream) return [3 /*break*/, 2];
                            return [4 /*yield*/, window.navigator.mediaDevices.getDisplayMedia({
                                    video: {
                                        cursor: "always",
                                    },
                                    audio: false,
                                })];
                        case 1:
                            stream = _a.sent();
                            this.$store.dispatch("setLocalScreenStream", stream);
                            _a.label = 2;
                        case 2:
                            stream.getVideoTracks()[0].addEventListener("ended", function () {
                                // The sharing was ended e.g. by clicking the chrome "Stop Sharing" button.
                                _this.$socket.sendWithoutSession("updateSharingState", {
                                    enabled: false,
                                });
                                _this.$store.dispatch("updateSharingScreenAndVideo", false);
                                _this.$store.dispatch("setLocalScreenStream", null);
                            });
                            this.$store.dispatch("setScreenShareError", null);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            this.$store.dispatch("setScreenShareError", err_1.message);
                            this.$store.dispatch("setLocalScreenStream", null);
                            this.$store.dispatch("updateSharingScreenAndVideo", false);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
        onScreenSharingChange: function (_a) {
            var target = _a.target;
            return __awaiter(this, void 0, void 0, function () {
                var enabled;
                var _this = this;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            enabled = target.checked;
                            if (!enabled) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.getScreenShareStream()];
                        case 1:
                            _b.sent();
                            if (!this.$store.getters.localScreenStream) {
                                return [2 /*return*/];
                            }
                            _b.label = 2;
                        case 2:
                            this.$socket.sendWithoutSession("updateSharingState", {
                                enabled: enabled,
                            });
                            if (!enabled) {
                                setTimeout(function () {
                                    _this.$store.dispatch("updateSharingScreenAndVideo", enabled);
                                });
                            }
                            return [2 /*return*/];
                    }
                });
            });
        },
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/OptionsMenuSelect.vue
// module id = 330
// module chunks = 1